import { useState } from 'react';

import { Box, Button, Container, Tooltip } from '@mui/material';
import _, { flowRight as compose } from 'lodash';
import { inject, observer } from 'mobx-react';
import { useRecoilState } from 'recoil';

import AxlSearchInput from 'AxlMUIComponent/AxlSearchInput';
import AxlDialog from 'components/AxlDialog';
import acl from 'constants/acl';
import TOOLTIP_DEFINED from 'constants/tooltip';
import VehicleAddNew from 'containers/VehicleAddNew';
import VehiclesList from 'containers/VehicleList';
import { vehicleState } from 'containers/VehicleList/state';

function VehicleScreen(props) {
  const { store } = props;
  const { permissionStore } = store;
  const [query, setQuery] = useRecoilState(vehicleState);
  const [isClose, setClose] = useState(true);

  const onSearch = (value) => {
    const _query = _.assign({}, query, { search_text: value, page_number: 0 });
    setQuery(_query);
  };

  const reloadSearch = (value) => {
    const _query = _.assign({}, query, { search_text: value });
    setQuery(_query);
  };

  const onClose = () => {
    setClose(true);
    reloadSearch('');
  };

  const isDeniedCreateVehicle = permissionStore.isDenied(acl.VEHICLES.EDIT);

  return (
    <Container maxWidth={false}>
      <Box display={'flex'} alignItems={'center'} gap={2}>
        {!isDeniedCreateVehicle && (
          <Tooltip title={TOOLTIP_DEFINED.ADD_NEW_VEHICLE} arrow>
              <Button variant="contained" color="primary" size="small" disableElevation onClick={() => setClose(false)} sx={{ p: 1 }}>
                + NEW
              </Button>
          </Tooltip>
        )}

        <Box flex={1}>
          <AxlSearchInput placeholder={'Search vehicles by vehicle name, vehicle info...'} searchAction={onSearch} />
        </Box>
      </Box>
      <VehiclesList onClose={onClose} />

      {!isClose && (
        <AxlDialog isOpen={!isClose} handleClose={onClose} childrenTitle={<Box fontWeight={700}>Add New Vehicle</Box>}>
          <VehicleAddNew onClose={onClose} />
        </AxlDialog>
      )}
    </Container>
  );
}

export default compose(inject('store'), observer)(VehicleScreen);
